import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, ɵgetHostElement, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { FileInfo, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { StockItemsService } from '~/services/modules/stocks/items';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { CustomersService } from '~/services/modules/stocks/customers';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { SalesOrder, SalesOrderDetail } from '~/front-models/salesOrderGrid';
import { SalesOrdersService } from '~/services/modules/stocks/sales-orders';
import { WindowService, WindowState } from '@progress/kendo-angular-dialog';
import { AccountsService } from '~/services/administration.ts/accounts';
import { parseDate } from '@progress/kendo-angular-intl';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { GridFieldSummary } from '~/models/modules/gridField';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { StocksCustomersUpsertComponent } from '../../../files/customers/upsert/upsert.component';
import { ReportsService } from '~/services/modules/reports/reports';
import { ReportViewerPopupComponent } from '~/shared/components/viewer/popup.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { SOToPOPreferencesService } from '~/services/administration.ts/so-to-po-preferences';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { CustomFieldSummary } from '~/models/modules/customField';
import { NoteComponent } from '~/shared/components/note/note.component';

import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { FormatService } from '~/services/administration.ts/format';
import { SharedService } from '~/services/sharedService';
import { TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { SOPreferencesService } from '~/services/administration.ts/so-preferences';
import { SOPreference } from '~/models/administration/soPreference';
import { StockSalesOrderResponseModel } from '~/models/modules/stockSalesOrderResponseModel';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';

import { ApproverDetailResponseModel } from '~/models/modules/approverDetailResponseModel';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { FilesService } from '~/services/modules/stocks/files';
import { SalesOrderSummary } from '~/models/modules/salesOrder';
import { SalesOrderFile } from '~/models/modules/SalesOrderFile';
import { fileSources } from '~/shared/enums/fileSources';
import { FileSelectedStream } from '~/models/modules/file';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { stockSalesOrderFile } from '~/models/modules/stockPurchaseOrderFile';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { EntityStatusOptions } from '~/models/entityStatus';
import { GDataService } from '~/services/GDataService';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { CustomerSummary } from '~/models/modules/customer';
import { SitesEnum } from '~/shared/enums/sites.enum';

@Component({
    selector: 'app-stock-sales-orders-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StockSalesOrdersUpsertComponent extends MultiSiteAwareComponent implements OnInit, AfterViewInit {
  _showDocumentsGrid: boolean = false;
  _selectedDocumentsKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _fileSource: fileSources;
  _uploadedStream: FileSelectedStream[] = [];
  _selectedExistingFiles: FileSelectedStream[] = [];
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _selectedAccounts: any[] = [];
  _uploaderSelectMessage: string = 'Upload file..';
  _selectedObjectDocuments: any[] = [];

  _currentStatus: string;

  uploadSaveUrl = "saveUrl";
  uploadRemoveUrl = "removeUrl";
  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _theme: string;
  _form: FormGroup;
  _file: File;
  _active: boolean;
  _isNew: boolean;
  _invalidForm: boolean;
  _model: any;
  _selectedAccount = new FormControl();

  _sortingSelected = new FormControl('old');
  _defaultQuantity = new FormControl();
  _defaultUnitPrice = new FormControl();
  _autoCodeGeneration = new FormControl();
  _inventoryCode = new FormControl();
  _selectFile: boolean = false;
  _quantity = new FormControl();
  _unitPrice = new FormControl();
  _expirationDate = new FormControl();
  // _sites: any[];
  // _sitesFiltered: any[];
  _addresses: any[];
  _addressesFiltered: any[];
  _customers: any[];
  _hasRequired: boolean = false;
  _customersFiltered: any[];
  _selectedStockItem = new FormControl();
  _soNumber = new FormControl();
  _poNumber = new FormControl();
  _items: any[];
  _itemsFiltered: any[];

  _inventoryGridData: SalesOrderDetail[] = [];
  _barcodePopupActive: boolean;

  _itemType: 'standard' | 'batch' | 'serial' | 'serial-with-quantity' | 'non-inventory';
  _defaultDate = new FormControl();

  _approvalCycleEnabled: boolean = false;
  _submitted: boolean = false;
  _isApprovalCycleManager: boolean = false;
  _firstApprovalPending: boolean = false;
  _firstApprovalAccepted: boolean = false;
  _secondApprovalPending: boolean = false;
  _secondApprovalAccepted: boolean = false;

  _isFirstApprover: boolean = false;
  _isSecondApprover: boolean = false;

  _stockItemFilesDocs: SalesOrderFile[] = [];
  _firstApprovalEnabled: boolean = false;
  _firstApprovalStatus: string = "pending";

  _secondApprovalEnabled: boolean = false;
  _secondApprovalStatus: string = "pending";

  _poOrderEnable: boolean = false;
  _poVendorEnable: boolean = false;

  _approvalCycleState: string = "pending";
  _showStocksGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];
  _stockItemsGridColumns: GridFieldSummary[];
  _showCustomersGrid: boolean = false;
  _selectedCustomers: any;
  _customersGridColumns: GridFieldSummary[];
  _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
  _showAddCustomerWindow: boolean = false;

  _minDate: Date = new Date(1901, 1, 1);
  _windowState: WindowState = 'maximized';
  _subtotal: number = 0;
  _shipping: number = 0;
  _discount: number = 0;
  _FileID: number = 0;
  _otherAdjustment: number = 0;
  _tax: number = 0;
  _total: number = 0;
  _showSave: boolean = true;
  showSOToPOWindow: boolean = false;
  showReports: boolean = false;
  salesOrderReports: any;
  transactionId: number;
  _addClassActive: boolean = false;
  _fileStream: any;
  _sOtoPOSettings: any;
  _SOtoPOGridData: any[] = [];
  _selectedSOtoPOOrderOption = new FormControl();
  _selectedSOtoPOVendorOption = new FormControl();
  _isStatusDisabled = false;
  _soToPOOrderData: any[] = [
    { id: 0, name: "No", value: false },
    { id: 1, name: "Yes", value: true }
  ];

  _soToPOVendorData: any[] = [
    { id: 0, name: "No", value: false },
    { id: 1, name: "Yes", value: true }
  ];

  _vendorsFiltered: any[];
  _vendors: any[];

  _soToPoAuth: any;

  // _stockItemFilesDocs: SalesOrderFile[] = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any;
  _note: string;
  DocumentUrl: string;
  _page: string = "salesOrders";
  _permissionScope = 'salesOrders';
  _index: number;
  _selectedLabelId: number;
  _selectedTabId: number;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isAddTabFormValue: boolean = false;
  _selectedAccountIds: any[] = [];
  _customTabs: any;
  _selectedLabelObjectCode: any;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _language: string = "en";
  _gridFieldText: GridFieldTextSummary[];
  _gridFieldAuth: GridFieldAuthorization[];
  _deactivatedFieldsGridData: Array<any> = [];
  okCloseSubscription: any = null;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _customFieldsDictionary: { [key: string]: string } = {};
  _pageState: PageState;
  _isOs: boolean;

  _datePickerFormat: string;

  _costFormat: string;

  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;

  soPreference: SOPreference;
  dispatchType: string[] = [];
  selectedDispatchValue: string;
  isPickUp: boolean = false;

  stockSalesOrder: StockSalesOrderResponseModel;
  creator: ApproverDetailResponseModel;
  isEditMode: boolean = false;
  isCopyMode: boolean = false;
  hasApprovalCycle: boolean = false;

  quantityFormat: string;
  digitNumber: number;

  _isEditForms: boolean = false;

  reactivate: boolean = false;
  reactivateItem: any;
  comboBoxpagingationParams = {
    currentItem: '0',
    totalbyPage: 20,
    page: 1,
    search: ''
  };

  prevoiusValue: string;
  beginScroll: boolean;
  clearTimeout: any;
  previousValue: string;
  isOpened: boolean = false;
  timeOut: any;
  isLoading: boolean = false;
  _itemFilter: string;
  autoCorrect: boolean = true;

  // #region Videos/Documents/Pictures
  _filesPageName: string = 'files';
  _documentsPageName: string = 'documents'
  _videosPageName: string = 'videos'
  _imageSearchControl = new FormControl();
  _documentSearchControl = new FormControl();
  _videoSearchControl = new FormControl();
  _showImagesGrid: boolean = false;
  //_showDocumentsGrid:boolean = false;
  _showVideoGrid: boolean = false;
  _imageSearchResult: string;
  _documentSearchResult: string;
  _videoSearchResult: string;
  _filesGridFields: GridFieldSummary[];
  _documentsGridFields: GridFieldSummary[];
  _videosGridFields: GridFieldSummary[];
  _filesGridFieldsSub!: Subscription;
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  //_selectedDocuments: any[] = [];
  //_selectedDocumentsKeys: number[] = [];
  _selectedVideos: any[] = [];
  _selectedVideosKeys: number[] = [];
  _purchaseOrderFilesPics: stockSalesOrderFile[] = [];
  _purchaseOrderFilesDoc: stockSalesOrderFile[] = [];
  _purchaseOrderFilesVideo: stockSalesOrderFile[] = [];
  _selectedObjectImages: any[] = [];
  //_selectedObjectDocuments: any[] = [];
  _selectedObjectVideos: any[] = [];
  _selectedUpsertImagesKeys: number[] = [];
  // #endregion
  _onlyRequired: boolean = false;
  _storagePath: any;

  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  quantityFormatType: FormatTypes = FormatTypes.QuantityFormat;

  _isTransaction: boolean = false;
  //#region New StockItem Combobox Fields
  _itemsNew: any[];
  _itemsFilteredNew: any[];
  _allStockItemsCount: number = 0;
  _stockItemComboBoxPagingParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1
  };
  _stockItemComboScroll: boolean = false;
  _stockItemDDSearch: string = null;
  //#endregion

  @Input() model: SalesOrder;

  @ViewChild('kendo_combo_items') drop: any;
  @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('kendo_combo_customers') kendoComboCustomers: ComboBoxComponent;
  @ViewChild('kendo_combo_addresses') kendoComboAddresses: ComboBoxComponent;
  @ViewChild('kendo_combo_items') kendoComboItems: ComboBoxComponent;
  @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('unitprice_input') unitPriceInput: NumericTextBoxComponent;
  @ViewChild('so_input') soInput: ElementRef;
  @ViewChild('textarea_customeraddress') customerAddressTextarea: ElementRef;
  @ViewChild('textarea_address') addressTextarea: ElementRef;
  @ViewChild('kendo_combo_Receipt_Report') selectReceiptReport: ComboBoxComponent;
  @ViewChild('kendo_combo_S_Order') kendoComboSOrder: ComboBoxComponent;
  @ViewChild('kendo_combo_S_Status') kendoComboSStatus: ComboBoxComponent;
  //@ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('kendo_uploader') upload: UploadComponent;
  @ViewChild('kendo_uploader') uploadWrapper: ElementRef;
  //#region Multi Site Variables

  //#endregion
  _showStockItemFileNotes: boolean = false;
  _stockItemNotesModel: StockItemSummary;
  _showCustomerFileNotes: boolean = false;
  _customerNotesModel: CustomerSummary;
  //#region Custom Fields Fix
  _customValidation: any = [];
  _entity = 'Stock';
  _systemFields: GridFieldSummary[] = [];
  _editedSystemFields: any = [];
  copyModelId: number;
  _requiredFieldNames: any = [];
  _requiredFields: any = [];
  requiredSystemTabs: any = [];
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;
  _additionalErrors: any = [];
  //#endregion
  constructor(
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _customersService: CustomersService,
    private _addressesService: AddressesService,
    private _salesOrdersService: SalesOrdersService,
    private _stockItemsService: StockItemsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private windowService: WindowService,
    private _reportService: ReportsService,
    private _securityService: SecurityService,
    private _soToPoPreferencesService: SOToPOPreferencesService,
    private _vendorsService: VendorsService,
    private _purchaseOrdersService: PurchaseOrdersService,
    private _customFieldsService: CustomFieldsService,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private _soPreferencesService: SOPreferencesService,
    private quantityFormatsService: QuantityFormatsService,
    public cdRef: ChangeDetectorRef,
    private _filesService: FilesService,
    private _renderer2: Renderer2,
    private _dataService: GDataService,
    private _multiSitesService: MultiSiteService,
  ) {
    super();

    this._getdata();
    this.LoadData();
    this.CreateDispatchType();

    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.isAttachment == true) {
        if ((str?.response || str?.picObject) && str.component == 'files') {
          this._addPicture(str);
        }
        if ((str?.response || str?.picObject) && str.component == 'documents') {
          this._addDocument(str);
        }
        if ((str?.response || str?.picObject) && str.component == 'videos') {
          this._addVideo(str);
        }
      }
      if (str?.isClosed) {
        this._isDialiog = false;
      }
    });


    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.okCloseClicked.subscribe((data) => {
      if (data) {
        setTimeout(() => {
          this.kendoComboItems.toggle(true);
          this.kendoComboItems.focus();
        });
      }
    });

    // this._customersService.customerClosed.subscribe((data) => {
    //   this._showAddCustomerWindow = false;
    //   if (data) {
    //     setTimeout(() => {
    //       var newlyAddedCustomer = this._customers.filter(
    //         (s) => s.code.toLowerCase() == data.toLowerCase()
    //       )[0];
    //       if (newlyAddedCustomer != null) {
    //         this._form.patchValue({
    //           customer: { id: newlyAddedCustomer.id, code: data }
    //         });
    //       }
    //     }, 200);
    //   }
    // });

    this._layoutManager.applyOverly();

    this._layoutManager.formChanged.subscribe((x) => {
      if (x === 'customers') {
        //this._loadCustomersDD();
      }

      if (x === 'addresses') {
        if (this._form.get('site').value) {
          //this._loadAddressesDD();
        }
      }
    });



    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {


      this._selectedDocumentsKeys = this._model.stockSalesOrderDetails.map((x: SalesOrderFile) => {
        return +x.salesOrderId;
      });


    }

    this._soPreferencesService.getSOPreference()

      .subscribe(res => {
        this.soPreference = res;
      });

    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
      });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
      this._stockItemsGridColumns = gridColumns;
    }));

    this._gridFields
      .getGridFieldsByPage('customers')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('customers', data);
      });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('customers', (gridColumns) => {
      this._customersGridColumns = gridColumns;
    }));
    this._currentUser = this._securityService.currentUser;

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    }

    /* if (this._selectedDocumentsKeys.length === 0) {
      this._showDocumentsGrid = false;
    } else {
      this._showDocumentsGrid = true;
    } */
    this.getSOTOPOAuth();

    // this._customersService.customerAdded.subscribe(x => {
    //   const customer = { code: x.code, id: x.id, name: x.name, entityAddress: x.entityAddress,
    //     customerShipToAddresses: x.customerShipToAddresses};
    //   this._customersFiltered.push(customer);
    //   this._form.controls['customer'].setValue(customer);
    //     this._handleCustomersChange(customer);

    // })
    this._customersService.customerAdded.subscribe(x => {
      if (x.siteId == this._form.controls['site'].value?.id || !x.siteId) {
        const customer = {
          code: x.code, id: x.id, name: x.name, entityAddress: x.entityAddress,
          customerShipToAddresses: x.customerShipToAddresses
        };
        this._customers.push(customer);
        this._customersFiltered = this._customers;

        this._form.controls['customer'].setValue(x);
        this._handleCustomersChange(x);
      }

    })
    // this._customersService.customerUpdated.subscribe((customer: any) => {
    //   var UpdatedRecord = this._vendors.find(x => x.id == customer.id);
    //   if(UpdatedRecord)
    //   {
    //     var Index = this._vendors.indexOf(UpdatedRecord);
    //     this._vendors[Index] = customer;
    //   }
    //   this._form.controls['customer'].setValue(customer);
    //   this._handleCustomersChange(customer);
    //   })
  }

  savebuttonvisability() {
    let resualt = this.isCopyMode || (!this.isEditMode || (this.isEditMode && (!this.stockSalesOrder?.isSubmitted && !this.stockSalesOrder?.isApproved))) && this._pageState != 1
    return resualt;
  }

  async LoadData() {
    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
    this._selectedSOtoPOVendorOption.setValue({ id: 0, name: "No", value: false });
    this._selectedSOtoPOOrderOption.setValue({ id: 0, name: "No", value: false });
    this._SOrderValueChanged({ id: 0, name: "No", value: false });
    this._SStatusValueChanged({ id: 0, name: "No", value: false });

  }

  GetDocumentFromSalesOrder(model: SalesOrderSummary) {
    if (model.salesOrderFiles && model.salesOrderFiles.length > 0) {
      if (model.salesOrderFiles[0].file && model.salesOrderFiles[0].file.stream && model.salesOrderFiles[0].file.stream.length > 0) {
        this.DocumentUrl = model.salesOrderFiles[0].file.stream;
      }
    }
  }
  ispendingstatus: any = false;
  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    if (this._model != undefined && this._model != null && this._model.approvers != undefined && this._model.approvers != null) {
      if (this._model.isClosed && this._model.stockSalesOrderStatusId == 6)
        this._currentStatus = 'Closed';
      else
        this._currentStatus = this._model.stockSalesOrderStatus.code

      let ispending = this._model.approvers.filter((a: any) => a.isPending === true)
      if (ispending !== undefined && ispending !== null) {
        this.ispendingstatus = true
      }

    }
    if (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && this._pageState !== PageState.ADD && !this.isCopyMode) {
      this._pageState = PageState.VIEW;
    }
    if (this._model && this._pageState == PageState.ADD) {
      this.copyModelId = this._model.id; // for loading custom fields data if there is any
    }
    this._purchaseOrderFilesPics = [];
    this._purchaseOrderFilesDoc = [];
    if (this._model?.stockSalesOrderFiles) {
      this._model.stockSalesOrderFiles.forEach((element: any) => {
        if (element.file?.type.includes('image')) {
          this._purchaseOrderFilesPics.push(element);
        }
        else if (element.file?.type.includes('video')) {
          this._purchaseOrderFilesVideo.push(element);
        }
        else {
          this._purchaseOrderFilesDoc.push(element);
        }
      });
    }


    var loggedInAccountSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));

    if (loggedInAccountSites && loggedInAccountSites.length > 0) {
      this.siteId = loggedInAccountSites[0].siteId;
    }

    if (this._model && this._model.id && this._model.id > 0) {
      this.isEditMode = true;
      this.stockSalesOrder = this._model;
      if (this.stockSalesOrder && this.stockSalesOrder.hasApprovalCycle !== undefined) {
        this.hasApprovalCycle = !!this.stockSalesOrder.hasApprovalCycle;
      }

      if (this.stockSalesOrder && this.stockSalesOrder.approvers && this.stockSalesOrder.approvers.length > 0) {
        this.creator = this.stockSalesOrder.approvers.find(f => f.isCreator == true);
      }

    }

    if (this._model && this._model.isPickUp) {
      this.SetPickUpConfiguration();
    }
    else if (this._model && !this._model.isPickUp) {
      this.SetShipConfiguration();
    }
    this._stockItemFilesDocs = this._model?.salesOrderFiles ? this._model.salesOrderFiles : [];

    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    if (this._pageState == 5) {
      this.isCopyMode = true;
      this._model.id = null;
    }
    if (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && this._pageState !== PageState.ADD && !this.isCopyMode) {
      this._pageState = PageState.VIEW;
    }
    this._isNew = this._sharedService.model.isNew;
    this._active = true;
    if (this._model && this._model.site) {
      this._loadSitesAndInitDD(true, this._model.site);
    }
    else {
      this._loadSitesAndInitDD();
    }
  }

  rertrievesalesorder(params: any) {

    this._salesOrdersService.getSalesOrder(params)

      .subscribe((model) => {
        this._model = model;
        this.stockSalesOrder = this._model;
        if (this.stockSalesOrder && this.stockSalesOrder.hasApprovalCycle !== undefined) {
          this.hasApprovalCycle = !!this.stockSalesOrder.hasApprovalCycle;
        }
        if (this.stockSalesOrder && this.stockSalesOrder.approvers && this.stockSalesOrder.approvers.length > 0) {
          this.creator = this.stockSalesOrder.approvers.find(f => f.isCreator == true);
        }
      });
  }

  _onUnitsIssuedChange(e: any, item: SalesOrderDetail) {
    item.unitsIssued = e;
    item.backorderQty = item.unitsOrdered - e;

    this._updateGridFooterValues();
  }

  SetPickUpConfiguration() {
    this.isPickUp = true;
    this.selectedDispatchValue = 'Pick-Up';
  }


  SetShipConfiguration() {
    this.isPickUp = false;
    this.selectedDispatchValue = 'Ship';
  }

  CreateDispatchType() {
    this.dispatchType = ['Pick-Up', 'Ship'];
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  private getItemType(itemTypeName: string) {
    switch (itemTypeName) {
      case 'Standard':
        return 'standard';
      case 'Serial':
        return 'serial';
      case 'Batch':
        return 'batch';
      case 'Non Inventory':
        return 'non-inventory';
      case 'Serial with Quantity':
        return 'serial-with-quantity';
    }
  }

  ngOnInit() {
    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';

    if (this._model != null && this._model.site != null && this._model.site.id != null && this._model.site.account != null && this._model.site.account.id != null) {
      //this._loadSitesAndInitDDDD(this._model.site.account.id, false);
    }
    //this._loadCustomersDD();
    //this._loadAddressesDD();

    this._initForm();

    if (this._model && !this._model.customerId) {
      this.SetShipConfiguration();
    }


    this._form.get('account').valueChanges.subscribe((x) => {
      if (x) {
        if (this._isNew || !this._submitted) {
          this._clearGridData();
          this._form.get('site').setValue(null);
          //this._loadSitesAndInitDDDD(x.id);
        }
      }
    });

    this._form.get('site').valueChanges.subscribe((x) => {
      if (x && this._pageState !== PageState.VIEW) {
        //this._clearGridData();
        // this._loadItemsDD(x.id);
        // this._getStockItems();

        setTimeout(() => {
          this.kendoComboCustomers.toggle(true);
          this.kendoComboCustomers.focus();
        });
      }
    });

    this._form.get('customer').valueChanges.subscribe((x) => {
      if (x && this._pageState !== PageState.VIEW) {
        setTimeout(() => {
          this.kendoComboAddresses.toggle(true);
          this.kendoComboAddresses.focus();
        });
      }
    });

    this._form.get('address').valueChanges.subscribe((x) => {
      if (x && this._pageState !== PageState.VIEW) {
        setTimeout(() => {
          if (this.soInput)
            this.soInput.nativeElement.focus();
        });
      }
    });

    this._soNumber.valueChanges.subscribe((x) => {
      if (x) {
        this._form.patchValue({
          soNumber: x.toString()
        });
      }
    });

    this._defaultDate.valueChanges.subscribe((x) => {
      if (x) {
        this._expirationDate.setValue(new Date());
      }
      this._quantity.valueChanges.subscribe((x) => {
        if (x && this._autoCodeGeneration.value) {
          if (this._itemType === 'serial' || !this._inventoryCode.value) {
            this.runGenerateBarcode();
          }
        }
      });
    });

    this._selectedStockItem.valueChanges.subscribe((x) => {

      if (x) {
        let gridItem = this._inventoryGridData.find(r => r.itemNumber === x.number);
        if (!gridItem) {
          this._inventoryCode.setValue('');

          this._itemType = this.getItemType(x.itemType.name);

          if (this._itemType === 'standard') {
            this._inventoryCode.setValue(x.number);
          } else {
            if (this._quantity.value && this._itemType !== 'non-inventory' && this._autoCodeGeneration.value) {
              this.runGenerateBarcode();
            }
          }

          if (this._defaultQuantity.value) {
            setTimeout(() => {
              this.fillGrid();
            });
          }
        }
      } else {
        this._itemType = null;
        this._inventoryCode.setValue(null);
        if (!this._defaultQuantity.value) {
          this._quantity.setValue(null);
        }

        if (this._defaultDate.value) {
          this._expirationDate.setValue(new Date());
        } else {
          this._expirationDate.setValue(null);
        }
      }
    });

    this._sortingSelected.valueChanges.subscribe((x) => {
      this._inventoryGridData.reverse();
    });
    this.getSOtoPOSettings();
    this.getFormTabs();
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getAuth();
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;

    //this._loadItems();
    this.getStockItemDDPaging(this._form.controls['site'].value?.id);

  }

  getMarkupType(obj: any, propString: any) {

    if (obj.costInfo.isCalculatedPrice)
      return "Calclulated Price"
    else if (obj.costInfo.isFixedPrice)
      return "Fixed Price"
  }
  displayCatImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.categoryFilePrimary == true);
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }
    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }

  displayStockImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.stockitemfileisprimary == true);
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }

    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }
  _closeStockItemNotesWindow() {
    this._showStockItemFileNotes = false;
  }
  _showStockItemNotesWindow(id: number) {
    this._stockItemsService.getStockItem(id)

      .subscribe((model: any) => {
        this._stockItemNotesModel = model;
        this._showStockItemFileNotes = true;
      });
  }
  getAccountNames(accounts: any[]): string {
    if (!accounts || !Array.isArray(accounts)) return '';
    const names = accounts
      .map(d => d?.account?.name ?? d?.name)
      .filter((name): name is string => typeof name === 'string' && name.trim().length > 0);
    return Array.from(new Set(names)).join(', ');
  }

  ngAfterViewInit(): void {
    this._OpenAccount();
  }

  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    }
    else {
      setTimeout(() => {
        // this.kendoComboCustomers.toggle(true);
        // this.kendoComboCustomers.focus();
      });
    }
  }
  _skipSOrder() {
    let SOrder = this.kendoComboSOrder;
    ɵgetHostElement(SOrder).classList.remove('focusedCombobox');
    this.kendoComboSOrder.toggle(false);
    this.kendoComboSOrder.blur();
    let SStatus = this.kendoComboSStatus;
    ɵgetHostElement(SStatus).classList.add('focusedCombobox');
    this.kendoComboSStatus.toggle(true);
    this.kendoComboSStatus.focus();
    this._addClassActive = false;
  }
  _skipSStatus() {
    let SStatus = this.kendoComboSStatus;
    ɵgetHostElement(SStatus).classList.remove('focusedCombobox');
    this.kendoComboSStatus.toggle(false);
    this.kendoComboSStatus.blur();
    this._addClassActive = true;
  }
  // _openedSOrder() {
  //     setTimeout(() => {
  //         let SOrder = this.kendoComboSOrder;
  //         SOrder['hostElement'].nativeElement.classList.add('focusedCombobox');
  //         this._addClassActive = false;
  //         let SStatus = this.kendoComboSStatus;
  //         SStatus['hostElement'].nativeElement.classList.remove('focusedCombobox');
  //     });
  // }
  // _openedsStatus() {
  //     setTimeout(() => {
  //         let SOrder = this.kendoComboSOrder;
  //         SOrder['hostElement'].nativeElement.classList.remove('focusedCombobox');
  //         this._addClassActive = false;
  //         let SStatus = this.kendoComboSStatus;
  //         SStatus['hostElement'].nativeElement.classList.add('focusedCombobox');
  //     });
  // }
  _SOrderValueChanged(event: any) {
    // this._selectedSOtoPOOrderOption.setValue(event.value);
    this._poOrderEnable = event.value
    this._SOtoPOGridData.forEach((value, index) => {
      if (index > 0)
        value.isDisabledPo = event.value == true ? true : false;
      else
        value.isDisabledPo = false;
    });
    if (event.value == true && this._SOtoPOGridData.length > 1 && this._SOtoPOGridData[0].PONumber != undefined) {
      this._SOtoPOGridData.forEach((value, index) => {

        if (value.PONumber == undefined)
          value.PONumber = {}
        if (index > 0)
          value.PONumber = this._SOtoPOGridData[0].PONumber
      });
    }

    //sync second combobox
    if (event.value == true) {
      const vendorYesEvent = { id: 1, name: "yes", value: true };
      this._SStatusValueChanged(vendorYesEvent);

      this._selectedSOtoPOVendorOption.setValue(vendorYesEvent);
      this._isStatusDisabled = true;

    }
    else
      this._isStatusDisabled = false;

    //   let SOrder = this.kendoComboSOrder;
    //   ɵgetHostElement(SOrder).classList.remove('focusedCombobox');
    //   this.kendoComboSOrder.toggle(false);
    //   this.kendoComboSOrder.blur();
    //   let SStatus = this.kendoComboSStatus;
    //   ɵgetHostElement(SStatus).classList.add('focusedCombobox');
    //   this.kendoComboSStatus.toggle(true);
    //   this.kendoComboSStatus.focus();
    //  this._addClassActive = false;
    // this._selectedSOtoPOOrderOption.setValue(event.value);
  }
  _SStatusValueChanged(event: any) {
    this._poVendorEnable = event.value
    //this._selectedSOtoPOVendorOption.setValue(event.value);
    this._SOtoPOGridData.forEach((value, index) => {
      if (index > 0)
        value.isDisabledVendor = event.value == true ? true : false;
      else
        value.isDisabledVendor = false;
    });
    if (event.value == true && this._SOtoPOGridData.length > 1) {
      this._SOtoPOGridData.forEach((value, index) => {
        if (index > 0 && this._SOtoPOGridData[0].vendor != null)
          value.vendor = this._SOtoPOGridData[0].vendor
      });
    }
    // ɵgetHostElement(SStatus).classList.remove('focusedCombobox');
    // this.kendoComboSStatus.toggle(false);
    // this.kendoComboSStatus.blur();
    // this._addClassActive = true;
    //  this._selectedSOtoPOVendorOption.setValue(event.value);
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }

  _handleAccountsChange(value: any) {
    this._clearGridData();
  }

  // _handleSitesChange(value: any) {
  //   this._clearGridData();
  // }
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }


  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }



  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  }

  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAllDocuments(this._selectedAccounts, params, model);
  }

  _getSelectedDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  }


  _loadSitesAndInitDDDD(accountId: number, toggle: boolean = true) {
    return this._accountsService.getSitesListByAccount(accountId)
      .subscribe((data: any) => {
        // this._sites = data.filter((x: { name: string }) => x.name != 'All Sites');
        // this._sitesFiltered = this._sites;
        // if (toggle) {
        //   setTimeout(() => {
        //     this.kendoComboSites.toggle(true);
        //     this.kendoComboSites.focus();
        //   });
        // }
      });
  }
  _fileRemoveEventHandler(e: any) {
    this._fileStream = null;
  }
  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        const reader = new FileReader();
        reader.readAsDataURL(file.rawFile);

        reader.onloadend = () => {
          this._fileStream = reader.result;
          if (this.checkFileExtention()) {
            let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
              stream: reader.result,
              size: file.rawFile.size,
              type: file.rawFile.type,
              name: file.rawFile.name,
              fileSource: fileSources.salesOrder,
              isNew: true
            });
            this._uploadedStream.push(_selectedFileModel);

          }
        };
      }
    });
    this._selectFile = this._fileSelectedChanges.length > 0;

    // this.checkFileExtention();
  }
  _onUploadClick() {

    let kendoUploader = this.uploadWrapper.nativeElement.querySelector('input');
    kendoUploader.click();
  }

  private checkFileExtention(): boolean {
    if (this._file.stream != null) {
      let fileStream = this._file.stream.toString();
      let fileType = this._file.type;
      if (!(fileStream.startsWith('JVBERi0xL') || fileStream.startsWith('UEsDBBQ') ||
        fileStream.startsWith('0M8R4KG') || fileStream.startsWith('77u/'))
        && !(fileType.includes('application/pdf')
          || fileType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          || fileType == 'application/vnd.ms-excel'
          || fileType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          || fileType == 'application/msword'
          || fileType == 'text/csv')) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Only DOC, XLSX, PDF and CSV extensions are allowed.',
          withoutConfirm: true
        });
        setTimeout(() => {
          this.upload.clearFiles();
          this._file = null;
          this._fileStream = null;
        });

        return false;
      }
      else {
        return true;
      }

    }
    // const allowedExtensions = ['doc', 'csv', 'xls', 'xlsx', 'pdf'];
    // const reg = /(?:\.([^.]+))?$/;
    // const fileType = reg.exec(fileUploadedName)[1];
    // if (allowedExtensions.indexOf(fileType) == -1) {
    //   this._layoutComponent.openPopup({
    //     title: 'Validation',
    //     message: 'Only DOC, XLSX, PDF and CSV extensions are allowed.',
    //     withoutConfirm: true
    //   });

    //   setTimeout(() => {
    //     this.upload.clearFiles();
    //     this._file = null;
    //     this._fileStream = null;
    //   });

    //   return false;
    // }
    else {
      return true;
    }
  }

  _loadCustomersDD(siteId: number = null, fromEdit: boolean = false) {
    return this._customersService.getCustomersListing(null, siteId).subscribe((data: any) => {
      this._customers = data;
      this._customersFiltered = data;

      if (this._model.customer) {
        if (fromEdit) {
          this._form.controls['customer'].setValue(this._customers.find(x => x.id == this._model.customer.id))
        }

        this._handleCustomersChange(this._form.controls['customer'].value, true);
      }

    });
  }

  _filterAddressesByCustomer(customer: any, FromEdit: boolean = false) {
    const customerId = customer?.id ?? (typeof customer === 'number' ? customer : null);
    if (!customerId) {
      this._addresses = [{ id: -1, name: "<No Address>" }];
      this._addressesFiltered = [{ id: -1, name: "<No Address>" }];
      return;
    }

    this._customersService.getCustomerShipToAddresses(customerId).subscribe((res: any) => {
      const list = Array.isArray(res) ? [...res] : (res?.data ? [...res.data] : []);
      list.unshift({ id: -1, name: "<No Address>" });
      this._addresses = list;
      this._addressesFiltered = list;

      if (FromEdit && this._model?.address?.id) {
        this._form.controls['address'].setValue(this._addresses.find(x => x.id == this._model.address.id));
        this._handleAddressesChange(this._form.controls['address'].value);
      }
    }, (err) => {
      console.error('Error loading customer ship-to addresses', err);
      this._addresses = [{ id: -1, name: "<No Address>" }];
      this._addressesFiltered = [{ id: -1, name: "<No Address>" }];
    });
  }

  _handleCustomersChange(value: any, FromEdit: boolean = false) {
    if (this.customerAddressTextarea?.nativeElement) {
      this.customerAddressTextarea.nativeElement.value = this._fillAddressDetails(value);
    }

    if (value && value.id > 0) {
      const hasAddress = value.entityAddress?.addressLine1 || value.addressLine1 || value.entityAddress?.city || value.city;
      if (!hasAddress) {
        this._customersService.getCustomer(value.id).subscribe((customer: any) => {
          if (customer) {
            value.entityAddress = customer.entityAddress;
            if (this.customerAddressTextarea?.nativeElement) {
              this.customerAddressTextarea.nativeElement.value = this._fillAddressDetails(customer);
            }
          }
        });
      }
    }

    if (value) {
      if (!FromEdit) {
        this._form.controls['address'].setValue(null);
        if (this.addressTextarea?.nativeElement) {
          this.addressTextarea.nativeElement.value = "";
        }
      }

      this._filterAddressesByCustomer(value, FromEdit);

      if (this._pageState !== PageState.VIEW) {
        setTimeout(() => {
          this.kendoComboCustomers?.toggle(false);
        });
      }

      if (this._form.controls['site']?.value?.id && value && value.id > 0) {
        this._customersService.CheckIfCustomerHasApprovalCycle(value.id, this._form.controls['site'].value.id).subscribe((result: any) => {
          this.hasApprovalCycle = !!result?.hasApprovalCycle;
        });
      } else {
        this.hasApprovalCycle = false;
      }
    } else {
      if (!FromEdit) {
        this._form.controls['address'].setValue(null);
        if (this.addressTextarea?.nativeElement) {
          this.addressTextarea.nativeElement.value = "";
        }
      }
      this._filterAddressesByCustomer(null);
      this.hasApprovalCycle = false;
    }
  }

  _fillAddressDetails(value: any) {
    var addressDetails = "";

    if (value != null) {
      value = (value.entityAddress == null) ? value : value.entityAddress;

      if (value.addressLine1 != null && value.addressLine1 != "") {
        addressDetails += value.addressLine1;
      }

      if (value.addressLine2 != null && value.addressLine2 != "") {
        addressDetails += "\n" + value.addressLine2;
      }

      if (value.city != null && value.city != "") {
        addressDetails += "\n" + value.city;
      }

      if (value.state != null && value.state != "") {
        if (value.city != null && value.city != "") {
          addressDetails += " " + value.state;
        }
        else {
          addressDetails += "\n" + value.state;
        }
      }

      if (value.zip != null && value.zip != "") {
        if (value.state != null && value.state != "") {
          addressDetails += " " + value.zip;
        }
        else {
          addressDetails += "\n" + value.zip;
        }
      }

      if (value.country != null && value.country != "") {
        addressDetails += "\n" + value.country;
      }
    }

    return addressDetails;
  }

  _handleCustomersFilter(value: any) {
    this._customersFiltered = this._customers.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadAddressesDD(siteId: number = null) {
    this._addresses = [{ id: -1, name: "<No Address>" }];
    this._addressesFiltered = [{ id: -1, name: "<No Address>" }];
    const currentCustomer = this._form?.controls['customer']?.value;
    if (currentCustomer) {
      this._filterAddressesByCustomer(currentCustomer);
    }
  }

  _handleAddressesChange(value: any) {
    if (this.addressTextarea?.nativeElement) {
      this.addressTextarea.nativeElement.value = this._fillAddressDetails(value);
    }
    if (this._pageState !== PageState.VIEW) {
      setTimeout(() => {
        this.kendoComboAddresses?.toggle(false);
      }, 1000);
    }
  }


  _handleDispatchChange(value: any) {
    if (value == "Pick-Up") {
      this.isPickUp = true;
    }
    else if (value == "Ship") {
      this.isPickUp = false;
    }

    if (this.addressTextarea?.nativeElement) {
      this.addressTextarea.nativeElement.value = "";
    }
    this._form.controls['address'].setValue(null);
  }

  _handleAddressesFilter(value: any) {
    if (!this._addresses) {
      this._addressesFiltered = [{ id: -1, name: "<No Address>" }];
      return;
    }

    if (!value) {
      this._addressesFiltered = [...this._addresses];
      return;
    }

    const term = value.toString().toLowerCase();
    this._addressesFiltered = this._addresses.filter((s) =>
      (s.name && s.name.toLowerCase().indexOf(term) !== -1) ||
      (s.code && s.code.toLowerCase().indexOf(term) !== -1) ||
      s.id === -1
    );
  }

  _loadItems() {
    this.prevoiusValue = this.comboBoxpagingationParams.search;
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';

    return this._stockItemsService.getStockItemsListingBySiteWithReceiveDetails(JSON.parse(loggedInAccountSites)[0].siteId, this.comboBoxpagingationParams).subscribe((data: any) => {
      if (this.comboBoxpagingationParams.search == '') {
        if (!this.beginScroll) {
          this._items = data.body;
          this._itemsFiltered = data.body;
        }
        else {
          this._items = [...this._itemsFiltered, ...data.body];
          this._itemsFiltered = [...this._itemsFiltered, ...data.body];
        }
      }
      else {
        if (!this.beginScroll) {
          this._items = data.body;
          this._itemsFiltered = data.body;
        }
        else {
          this._items = [...this._itemsFiltered, ...data.body];
          this._itemsFiltered = [...this._itemsFiltered, ...data.body];
        }
      }
    });
  }

  _loadItemsDD(siteId: number) {
    this.previousValue = this.comboBoxpagingationParams.search;

    return this._stockItemsService.getStockItemsListingBySiteWithPoDetails(siteId, this.comboBoxpagingationParams).subscribe((data: any) => {
      if (this.comboBoxpagingationParams.search == '') {
        if (!this.beginScroll) {
          this._itemsFiltered = data.body;
          this._items = data.body;

        }
        else {
          this._itemsFiltered = [...this._itemsFiltered, ...data.body];

          if (this.comboBoxpagingationParams != null)
            this.comboBoxpagingationParams.page += 1;
        }
      }
      else {
        if (!this.beginScroll) {
          this._itemsFiltered = data.body;
          this._items = data.body;
        }
        else {
          this._itemsFiltered = [...this._itemsFiltered, ...data.body];
        }
      }
    });
  }

  _XXloadItemsDD(siteId: number, selectedStockNumber: string = null) {
    return this._stockItemsService.getStockItemsListingBySiteWithReceiveDetails(siteId, this.comboBoxpagingationParams).subscribe((data: any) => {
      if (selectedStockNumber != null) {
        var newStock = this._items.filter(x => x.number == selectedStockNumber)[0];
        this.quantityInput.focus();
        setTimeout(() => {
          this._selectedStockItem.setValue(newStock);
        });
      }
    });
  }

  _handleItemsFilter(value: any) {
    if (this.timeOut) clearTimeout(this.timeOut);

    var doneTypingInterval = 10;  //time in ms, 5 seconds for example
    this._itemFilter = value;
    this.timeOut = setTimeout(() => {
      this.comboBoxpagingationParams.search = this._itemFilter;
      this.comboBoxpagingationParams.currentItem = '0';

      this._itemsFiltered = this._items.filter((x: any) => x.number.toLowerCase().includes(value.toLowerCase()));

      if (this._model != null && this._model.id != null && this._model.site != null && this._model.site.id != null) {
        //this._loadItemsDD(this._model.site.id);
      }
      else {
        var siteId = this._form.get('site').value;

        //this._loadItemsDD(siteId.id);
      };
    }, doneTypingInterval);
  }

  _handleItemsChange(value: any) {
    if (value != null) {
      setTimeout(() => {
        this.quantityInput.focus();
      }, 500);
    }

    this._unitPrice.setValue(this.CalculateUnitPrice(value));
  }

  CalculateUnitPrice(stockItem: any) {
    var unitPrice = 0;
    if (stockItem && stockItem.costInfo) {
      if (stockItem.costInfo.fixedUnitPrice) {
        unitPrice = stockItem.costInfo.fixedUnitPrice;
      }
      else {
        var receiveUnitCost = stockItem.costInfo.cost;
        var inventoryUnitCost = receiveUnitCost / stockItem.receiveUnitOfMeasure.multiplier;

        var issueUnitBaseCost = inventoryUnitCost * stockItem.issueUnitOfMeasure.multiplier;
        unitPrice = issueUnitBaseCost + (issueUnitBaseCost * (stockItem.costInfo.markupPercent / 100)) + stockItem.costInfo.markupNumber;
      }

      if (!unitPrice)
        unitPrice = 0;
    }

    return unitPrice;
  }

  _quantitySubmited() {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    if ((this._defaultUnitPrice.value == null || this._defaultUnitPrice.value == false) && this.unitPriceInput.value == null) {
      this.unitPriceInput.focus();
      return;
    }

    if (this._selectedStockItem.value) {
      this.fillGrid();
    }
    else {
      setTimeout(() => {
        this.kendoComboItems.toggle(true);
        //this.kendoComboItems.focus();
      });
    }
  }

  _removeHandler({ sender, dataItem }: any) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != dataItem.itemNumber);
    this._updateGridFooterValues();
  } _removePoGrid({ sender, dataItem }: any) {
    this._SOtoPOGridData = this._SOtoPOGridData.filter((x: any) => x.stockItemId != dataItem.stockItemId); if ((dataItem.isDisabledPo == false)) {
      this._SOtoPOGridData[0].isDisabledPo = false;
    }
    if ((dataItem.isDisabledVendor == false)) {
      this._SOtoPOGridData[0].isDisabledVendor = false;
    }
  }

  _onOrderQuantityChange(e: any, item: SalesOrderDetail) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    item.unitsOrdered = e;
    item.extendedPrice = e * item.unitPrice;
    //item.backorderQty = item.unitsOrdered
    item.backorderQty = item.unitsOrdered - item.unitsIssued

    this._updateGridFooterValues();
  }

  _removeDocHandlerXXXX(event: SalesOrderFile) {
    const index = this._stockItemFilesDocs.indexOf(event, 0);
    if (index > -1) {
      this._stockItemFilesDocs.splice(index, 1);
    }
  }

  _setPrimaryDoc(data: any) {
    this._stockItemFilesDocs.forEach((element: any) => {
      if (element !== data) {
        element.salesOrderFilePrimary = false;
      }
    })
  }

  _onUnitPriceChange(e: any, item: SalesOrderDetail) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    item.unitPrice = e;
    item.extendedPrice = e * item.unitsOrdered;

    this._updateGridFooterValues();
  }

  _onShippingChange(e: any) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    this._shipping = e;
    this._updateGridFooterValues();
  }

  _onDiscountChange(e: any) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    this._discount = e;
    this._updateGridFooterValues();
  }

  _onOtherAdjustmentChange(e: any) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    this._otherAdjustment = e;
    this._updateGridFooterValues();
  }

  _onTaxChange(e: any) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    this._tax = e;
    this._updateGridFooterValues();
  }

  _updateGridFooterValues() {
    this._subtotal = this._inventoryGridData.reduce((sum, current) => sum + current.extendedPrice, 0);
    this._total = this._subtotal + this._shipping - this._discount - this._otherAdjustment + this._tax;
  }

  _openForm(componentName: string) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD };
  }

  _closeDialog(event: any) {
    if (event?.response && event.component == 'files') {
      this.GetDocumentById(event.response);
      this._isDialiog = event.open;
    }
    else {
      this._isDialiog = event;
    }
  }

  _selectStocksHandler(): void {
    this._showStocksGrid = true;
  }

  _returnSelectedStocksHandler(e: any[]): void {

    this._showStocksGrid = false;
    this._selectedStocks.forEach((item: StockItemSummary) => {
      this._inventoryCode.setValue('');
      this._itemType = this.getItemType(item.itemType.name);

      if (this._itemType === 'standard' || !this._autoCodeGeneration.value) {
        if (this._itemType === 'standard') {
          this._inventoryCode.setValue(item.number);
          this._expirationDate.setValue(null);
        }
        let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);

        (this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0);
        if (!gridItem) {
          this._inventoryGridData.push({
            id: item.id,
            backorderQty: 0,
            unitsIssued: 0,
            stockItemId: item.id,
            itemNumber: item.number,
            description: item.description,
            unitsOrdered: this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0,
            // uom: item.receiveUnitOfMeasure.code,
            uom: item.issueUnitOfMeasure.code,
            unitPrice: this.CalculateUnitPrice(item),
            extendedPrice: this.CalculateUnitPrice(item) * (this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0),
            // unitPrice: this._defaultUnitPrice.value ? ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0) : (this._unitPrice.value ?? 0),
            // extendedPrice: (this._defaultUnitPrice.value ? ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0) : (this._unitPrice.value ?? 0)) * (this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0),
            isTaxable: (item.costInfo != null && item.costInfo.isTaxable != null) ? item.costInfo.isTaxable : false,
          });
        }
      }
      //else {
      //     if (this._itemType !== 'non-inventory' && this._autoCodeGeneration.value) {
      //         this.runGenerateBarcode(item);
      //     }
      // }
    });
  }

  _getStockItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    // if (model != null && model.filter != null && this._form.get('site').value != null && this._form.get('site').value.id != null) {
    //model.SiteId = this._form.get('site').value.id;

    return this._stockItemsService.getStockItems(params, model, this._form.controls['site'].value?.id);
    //    }
  }

  _closeStocksWindow(): void {
    this._showStocksGrid = false;
  }

  _onStockRowSelectionChanges(e: any[]) {
    this._selectedStocks = [];
    e.forEach((item) => {
      this._selectedStocks.push(item);
    });
  }

  _selectCustomersHandler(): void {
    this._showCustomersGrid = true;
  }

  _returnSelectedCustomerHandler(e: any[]): void {
    this._showCustomersGrid = false;
    this._form.patchValue({
      customer: this._selectedCustomers[0]
    });
    this._handleCustomersChange(this._selectedCustomers[0]);
  }

  _getCustomers = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._customersService.getCustomers(params, model, this._form.controls['site'].value?.id);
  }

  _closeCustomersWindow(): void {
    this._showCustomersGrid = false;
  }

  _onCustomerRowSelectionChanges(e: any[]) {
    this._selectedCustomers = [];
    e.forEach((item) => {
      this._selectedCustomers.push(item);
    });
  }

  _openAddCustomer() {
    this._showAddCustomerWindow = true;
    setTimeout(() => {
      const windowRef = this.windowService.open({
        title: 'Add New Customer',
        content: StocksCustomersUpsertComponent,
        width: 956
      });
    });
  }

  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter).subscribe((data: any) => {
      this._soNumber.setValue(data.result.toString());
      this._form.patchValue({ soNumber: data.result.toString() });

      setTimeout(() => {
        this.kendoComboItems.toggle(true);
        this.kendoComboItems.focus();
      });
    });
  }

  _generatePOBarcodeClick(event: any) {
    let counter = 1;
    this.generatePOBarcode(counter)

      .subscribe((data: any) => {
        if (this._selectedSOtoPOOrderOption.value?.value === true) {
          this._SOtoPOGridData.forEach((element: any) => {
            element.PONumber = data.result;
          });
        }
        else
          this._SOtoPOGridData[event].PONumber = data.result.toString();
      });
  }

  private checkInventoriesValiation(): boolean {
    // for (let item of this._inventoryGridData) {
    //     if (item.itemType === 'standard') {
    //         if (item.quantity <= 0) {
    //             return false;
    //         }
    //     }

    //     if (item.itemType === 'non-inventory') {
    //         if (item.quantity <= 0 || !item.inventoryCode) {
    //             return false;
    //         }
    //     }

    //     if (item.itemType !== 'non-inventory' && item.itemType !== 'standard') {
    //         if (item.quantity <= 0 || !item.inventoryCode || !item.expirationDate) {
    //             return false;
    //         }
    //     }
    // }

    return true;
  }
  _returnSelectedDocumentsHandlerXXXX(e: any): void {
    this._selectedExistingFiles = [];
    this._selectedDocumentsKeys = [];
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentsGrid = false;
        let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
        this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
          return currentSelected.indexOf(c) === index;
        });
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
      this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
        return currentSelected.indexOf(c) === index;
      });
      this._selectedDocumentsKeys.forEach((v) => {
        let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
          stream: '',
          size: 0,
          type: '',
          name: '',
          fileSource: fileSources.salesOrder,
          isNew: false,
          existingFileId: v
        });
        this._selectedExistingFiles.push(_selectedFileModel);
        this._uploaderSelectMessage = 'Upload file..' + ` [ ${this._selectedExistingFiles.length} file(s) selected ]`;
      });
      //this._addSalesOrderDDocument();
    }
  }

  _addSalesOrderDDocument() {

    this._stockItemFilesDocs = this._stockItemFilesDocs === null ? [] : this._stockItemFilesDocs;

    if (this._selectedObjectDocuments.length > 0) {
      this._selectedObjectDocuments.forEach((element: any) => {
        let stockItemFile: SalesOrderFile = new SalesOrderFile();
        stockItemFile.fileId = element.id;
        stockItemFile.fileName = element.name;
        stockItemFile.file = element;
        const reader = new FileReader();
        this._file = element;
        //reader.readAsDataURL(this._file);
        reader.onloadend = () => {
          this._fileStream = reader.result;
        };
        this._selectFile = true;
        this.checkFileExtention();
        this._stockItemFilesDocs.push(stockItemFile);
        //this._fileSelectedChanges(stockItemFile)

      });

    }

  }
  _closeDocumentsWindowXXXX(): void {
    this._showDocumentsGrid = false;
  }

  _selectImagesHandlerXXXX(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentsGrid = true;
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = true;
    }
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('salesOrders', quantity);
  }

  private generatePOBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('purchaseOrders', quantity);
  }

  GetDocumentById(id: number) {
    this._filesService.getFile(id).pipe().subscribe((data) => {

      var salesOrderFile = new SalesOrderFile();
      salesOrderFile.file = data;

      this._stockItemFilesDocs.push(salesOrderFile);
    });
  }

  private _initForm() {
    //this._loadAddressesDD();
    if (this._model === null) {
      this._model = {};
    }
    if (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && this._pageState !== PageState.ADD && !this.isCopyMode) {
      this._pageState = PageState.VIEW;
    }

    this._form = this._fb.group({
      customer: [this._model.customer ?? null, Validators.required],
      address: [this._model.address ?? null],
      account: [(this._model.site && this._model.site.account) ?? null, Validators.required],
      site: [this._model.site ?? null, Validators.required],
      isClosed: [this._model.isClosed ? this._model.isClosed.toString() : 'false'],
      orderDate: [this._model.orderDate ? parseDate(this._model.orderDate) : new Date(), Validators.required],
      soNumber: [this._model.soNumber ?? null, Validators.required],
      dueDate: [this._model.dueDate ? parseDate(this._model.dueDate) : null],
      expectedDeliveryDate: [this._model.expectedDeliveryDate ? parseDate(this._model.expectedDeliveryDate) : null]
    });
    if (this._pageState === PageState.VIEW) {
      this._form.disable();
      this._selectedAccount.disable();
      this._selectedStockItem.disable();
      this._quantity.disable();
      this._unitPrice.disable();
      this._defaultQuantity.disable();
      this._defaultUnitPrice.disable();
      this._soNumber.disable();
    }
    this.setSiteId();
    /* if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
      if (loggedInAccountSites != "") {
        this._form.patchValue({
          account: { id: JSON.parse(loggedInAccountSites)[0].accountId, name: "" },
          site: { id: JSON.parse(loggedInAccountSites)[0].siteId, name: "" }
        });
        this._loadItemsDD(JSON.parse(loggedInAccountSites)[0].siteId);
      }
    } */

    if (this._model != null && this._model.id != null) {
      this.transactionId = parseInt(this._model.id);
    }

    if (this._model != null && this._model.id != null && this._model.site != null && this._model.site.id != null) {
      //this._loadItemsDD(this._model.site.id);
    }

    if (this._model.stockSalesOrderStatus != null) {
      this._approvalCycleEnabled = this._model.hasApprovalCycle;
      this._submitted = (this._model.stockSalesOrderStatusId != null && this._model.stockSalesOrderStatusId == 1) ? false : true;
      //this._isFirstApprover = this._model.stockSalesOrderApproval.approval1PersonId == this._model.currentPersonId ? true : false;
      //this._isSecondApprover = this._model.stockSalesOrderApproval.approval2PersonId == this._model.currentPersonId ? true : false;

      //this._firstApprovalEnabled = this._model.stockSalesOrderApproval.enableApproval1;
      this._firstApprovalStatus = (this._model.stockSalesOrderStatusId != null && (this._model.stockSalesOrderStatusId == 4 || this._model.stockSalesOrderStatusId == 6)) ? "completed" : "pending";

      //this._secondApprovalEnabled = this._model.stockSalesOrderApproval.enableApproval2;
      this._secondApprovalStatus = (this._model.stockSalesOrderStatusId != null && this._model.stockSalesOrderStatusId == 6) ? "completed" : "pending";

      if (this._model.stockSalesOrderStatusId != null) {
        if (this._model.stockSalesOrderStatusId == 2) {
          this._approvalCycleState = "closed";
        }
        else if (this._model.stockSalesOrderStatusId == 1) {
          this._approvalCycleState = "open";
        }
        else if (this._model.stockSalesOrderStatusId == 5) {
          this._approvalCycleState = "rejected";
        } else if (this._model.stockSalesOrderStatusId == 6) {
          this._approvalCycleState = "completed";
        } else {
          this._approvalCycleState = "pending";
        }
      }
    }

    setTimeout(() => {

      if (this._model != null && this._model.customer != null) {
        //this._handleCustomersChange(this._model.customer);
      }
      if (this._model != null && this._model.address != null) {
        this._handleAddressesChange(this._model.address);
      }

      else {
        if (!this._isNew) {
          this._form.patchValue({
            address: { id: -1, name: "<No Address>" }
          });

          if (this._isNew || !this._submitted) {
            // setTimeout(() => {
            //     this.kendoComboAccounts.toggle(true);
            //     this.kendoComboAccounts.focus();
            // });
          }
        }
      }
    }, 0);

    this._defaultUnitPrice.setValue(true);

    this._subtotal = this._model.subtotal ?? 0;
    this._shipping = this._model.shipping ?? 0;
    this._discount = this._model.discount ?? 0;
    this._otherAdjustment = this._model.otherAdjustment ?? 0;
    this._tax = this._model.tax ?? 0;
    this._total = this._model.total ?? 0;

    if (this._model != null && this._model.soNumber != null) {
      this._soNumber.setValue(this._model.soNumber);
      try {
        this._form.controls.customer.setValue(this._model.customer)
      } catch (error) {
      }

    }
    if (this._model != null && this._model.stockSalesOrderDetails != null) {
      this._model.stockSalesOrderDetails.forEach((item: SalesOrderDetail) => {
        this._stockItemsService.getStockItem(item.stockItemId)

          .subscribe((data) => {
            this._inventoryGridData.push({
              id: item.id,
              unitsIssued: this._pageState == 5 ? 0 : item.unitsIssued,
              backorderQty: item.unitsOrdered > 0 && item.unitsIssued > 0 && this._pageState != 5 ? (item.unitsOrdered - item.unitsIssued) : item.unitsOrdered,
              stockItemId: item.stockItemId,
              itemNumber: data.number,
              description: data.description,
              unitsOrdered: item.unitsOrdered,
              uom: data.receiveUnitOfMeasure.code,
              unitPrice: item.unitPrice,
              extendedPrice: item.extendedPrice,
              isTaxable: item.isTaxable
            });
            this._updateGridFooterValues();
          });
      });
    }

    this._closeDocumentsWindow();
  }

  private retrieveGridaftersave(params?: any) {
    if (this._inventoryGridData != undefined && this._inventoryGridData != null) {
      let countofzeroIds = this._inventoryGridData.filter((x: any) => x.id == 0).length;
      if (countofzeroIds <= 0) return;
    }


    let modeldata: any
    params = this._model.id
    this._salesOrdersService.getSalesOrder(params)

      .subscribe((model) => {
        modeldata = model
        this._inventoryGridData = [];
        modeldata.stockSalesOrderDetails.forEach((element: any) => {
          this._inventoryGridData.push({
            id: element.id,
            backorderQty: 0,
            unitsIssued: 0,
            stockItemId: element.stockItemId,
            itemNumber: element.stockItem.number,
            description: element.stockItem.description,
            unitsOrdered: Number(element.unitsOrdered),
            uom: element.stockItem.issueUnitOfMeasure.code,
            unitPrice: element.unitPrice,
            extendedPrice: element.extendedPrice,
            isTaxable: element.isTaxable ?? element.stockItem.costInfo?.isTaxable
          });
        });



      });

  }
  private setSiteId() {
    if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
      if (loggedInAccountSites != "") {
        this._form.patchValue({
          account: { id: JSON.parse(loggedInAccountSites)[0].accountId, name: "" },
          //site: { id: JSON.parse(loggedInAccountSites)[0].siteId, name: "" }
        });
        //this._loadItemsDD(JSON.parse(loggedInAccountSites)[0].siteId);
      }
    }
  }
  private fillGrid() {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      return;
    }
    let item = this._selectedStockItem.value;
    let gridItem = this._inventoryGridData.find(x => x.itemNumber === item.number);
    this._stockItemsService.getStockItem(item.id)

      .subscribe((data) => {
        if (gridItem) {
          this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != gridItem.itemNumber);
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Duplicate item is found. The old entry has been removed.',
            returnAfterOkCloseClick: true,
            withoutConfirm: true
          });
        }
        this._inventoryGridData.push({
          id: 0,
          stockItemId: data.id,
          backorderQty: this._quantity.value ? +this._quantity.value : 1,
          unitsIssued: 0,
          itemNumber: data.number,
          description: data.description,
          unitsOrdered: this._quantity.value ? +this._quantity.value : 1,
          uom: data.issueUnitOfMeasure.code,
          unitPrice: this._unitPrice.value ?? 0,
          extendedPrice: (this._unitPrice.value ?? 0) * (this._quantity.value ? +this._quantity.value : 1),
          isTaxable: data.costInfo?.isTaxable
        });

        this._selectedStockItem.setValue(null);
        setTimeout(() => {
          this.kendoComboItems.toggle(true);
          this.kendoComboItems.focus();
        });

        this._updateGridFooterValues();
      });
  }


  ApproveRejectSalesOrder(approve: boolean) {
    var body: any = {
      isApproved: approve,
      IsRejected: !approve
    }
    this._salesOrdersService
      .ApproveRejectSalesOrder(this.stockSalesOrder.id, body)

      .subscribe(() => {
        this._closeForm();
      });

  }
  //#region Stock Item With Paging Dropdown
  getStockItemDDPaging(siteId?: number): void {
    if (!this._stockItemComboScroll) {
      this._stockItemsService.getstockItemListingWithPaging(siteId, this._stockItemComboBoxPagingParams)

        .subscribe((data: any) => {
          this._allStockItemsCount = data.body.returnCount;
          this._itemsNew = [...data.body.data];
          this._itemsFilteredNew = [...data.body.data];
        });
    }
    else {
      this._stockItemsService.getstockItemListingWithPaging(siteId, this._stockItemComboBoxPagingParams)

        .subscribe((data: any) => {
          this._itemsNew = this._itemsNew.concat(data.body.data);
          this._itemsFilteredNew = [...this._itemsNew];
        });
    }
  }
  _handleItemsFilterDropDownPaging(_filter: any) {
    this._stockItemDDSearch = _filter;
    this._stockItemComboScroll = false;
    setTimeout(() => {
      this._stockItemComboBoxPagingParams.search = _filter;
      this._stockItemComboBoxPagingParams.currentItem = '0';
      this._stockItemComboBoxPagingParams.page = 1;
      this.getStockItemDDPaging(this._form.controls['site'].value?.id);
    }, 1000);
  }
  scrollComboboxNew(event: any) {
    this.isOpened = true;
    if (this.clearTimeout) clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        let domobject = document.querySelector('.k-list-content');
        if (domobject) {
          this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
            if (this._itemsNew.length < this._allStockItemsCount) {
              if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
                this._stockItemComboScroll = true;
                this._stockItemComboBoxPagingParams.currentItem = (parseInt(this._stockItemComboBoxPagingParams.currentItem) + this._stockItemComboBoxPagingParams.totalbyPage).toString();
                this._stockItemComboBoxPagingParams.page++;
                this.getStockItemDDPaging(this._form.controls['site'].value?.id);
              }
            }
          });
        }
      }
    }, 500);
  }
  //#endregion
  _saveAndPrint() {
    this._onSave(false, true, 'print');
  }

  _saveAndNew() {
    this._onSave(false, true, 'new');
  }

  _saveAndCopy() {
    this._onSave(false, true, 'copy');
  }

  OnSubmit() {
    this._onSave(true, false, 'submit');

  }

  async _onSave(isSubmit = false, saveOnly: boolean = false, afterSave: string = '') {
    // if(this._uploadedStream.length > 0 || this._selectedExistingFiles.length > 0){
    //   await this._saveTransactionFiles(isSubmit, saveOnly, afterSave);

    // }
    // else {
    this._addSalesOrder(isSubmit, saveOnly, afterSave);
    // }
  }

  async _saveTransactionFiles(isSubmit: boolean = false, saveOnly: boolean = false, afterSave: any) {
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];

    if ((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)) {
      let _filesModel: any[] = [];
      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.salesOrder;
        _filesModel.push(model);
      });

      await this._filesService
        .createFileRange(_filesModel)

        .toPromise()
        .then((response: number[]) => {
          if (response != null) {

            existingFiles.forEach((v) => {
              let ext = response.find(r => r == v.existingFileId);
              if (ext == undefined) {
                response.push(v.existingFileId);
              }
            });

            this._addSalesOrder(isSubmit, saveOnly, afterSave, response);
          }
        });
    }
  }
  async _addSalesOrder(isSubmit: boolean = false, saveOnly: boolean = false, afterSave: any, fileIds?: number[]) {
    if (this._pageState == PageState.VIEW || (this._model && (this._model.isClosed === true || this._model.isClosed === 'true' || this._model.stockSalesOrderStatusId === 2) && !this.isCopyMode)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Closed Sales Orders cannot be modified.',
        withoutConfirm: true
      });
      return;
    }
    if (!this._inventoryGridData.length) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add items to create the Sales Order.',
        withoutConfirm: true
      });
    }
    else if (!this.checkInventoriesValiation()) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the required fields in the grid.',
        withoutConfirm: true
      });
    }
    // else if (this.isPickUp == false && !this._form.get('address').value) {
    //   this._layoutComponent.openPopup({
    //     title: 'Validation',
    //     message: 'Please fill the ship to field',
    //     withoutConfirm: true
    //   });
    // }
    else if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    // else if (this._form.invalid) {
    //   this._invalidForm = true;
    // }
    else {
      let model: any = {};
      this._invalidForm = false;

      let formModel = this._form.value;

      if (this._model != null && this._model.id != null) {
        model['id'] = this._model.id;
      }
      // work with custom fields
      // if (this._customFieldsValue) {
      //   const entries = Object.entries(this._customFieldsValue);
      //   for (const [index, [key, value]] of entries.entries()) {
      //     this._customFieldsDictionary[key] = `${value}`;
      //   }
      // }
      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      if (this.stockSalesOrder && this.stockSalesOrder.id && this.stockSalesOrder.id > 0) {
        model['id'] = this.stockSalesOrder.id;
      }

      model['customFieldsValue'] = this._customFieldsDictionary;
      model['SalesOrderFiles'] = this._stockItemFilesDocs;

      if (formModel.isClosed == 'true') {
        formModel.isClosed = true
      }
      else {
        formModel.isClosed = false
      }

      model['isClosed'] = formModel.isClosed == null ? 'false' : formModel.isClosed;
      model['soNumber'] = formModel.soNumber;
      model['orderDate'] = formModel.orderDate;

      model['dueDate'] = formModel.dueDate;
      model['fileId'] = this._FileID;
      model['expectedDeliveryDate'] = formModel.expectedDeliveryDate;
      model['siteId'] = formModel.site.id;

      if (model['isClosed'] == 'true') {
        model['stockSalesOrderStatusId'] = 2;
      }
      else {
        model['stockSalesOrderStatusId'] = (this._model.stockSalesOrderStatus == null) ? 1 : this._model.stockSalesOrderStatus.id;
      }

      model['customerId'] = (formModel.customer == null) ? null : formModel.customer.id;
      model['addressId'] = (formModel.address == null) ? null : ((formModel.address.id == -1) ? null : formModel.address.id);
      model['siteId'] = (formModel.site == null) ? null : formModel.site.id;

      model['items'] = this._inventoryGridData.map((x) => {
        return {
          id: x.id,
          stockItemId: x.stockItemId,
          unitsIssued: x.unitsIssued,
          unitsOrdered: Number(x.unitsOrdered)?.toFixed(this.digitNumber),
          unitPrice: x.unitPrice,
          extendedPrice: x.extendedPrice,
          isTaxable: x.isTaxable
        };
      });

      model['subtotal'] = this._subtotal;
      model['shipping'] = this._shipping;
      model['discount'] = this._discount;
      model['otherAdjustment'] = this._otherAdjustment;
      model['tax'] = this._tax;
      model['total'] = this._total;
      model['isPickUp'] = this.isPickUp;
      model['note'] = this._note;

      let _transactionFiles: stockSalesOrderFile[] = [];
      _transactionFiles.push(...this._purchaseOrderFilesPics);
      _transactionFiles.push(...this._purchaseOrderFilesDoc);
      _transactionFiles.push(...this._purchaseOrderFilesVideo);

      if (model['SalesOrderFiles'] == undefined) {
        model['SalesOrderFiles'] = [];
      }

      _transactionFiles.forEach((v) => {
        let item: any = {};
        item.fileid = v.fileId;
        item.stockPurchaseOrderId = v.stockPurchaseOrderId
        model['SalesOrderFiles'].push(item);
      });

      if (isSubmit == true) {
        this._salesOrdersService.SubmitSalesOrder(model).subscribe((response: any) => {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response.message,
            withoutConfirm: true
          });

          this._closeForm();
        });
      }
      else {
        if (this._model.id) {
          this._salesOrdersService.updateSalesOrder(this._model.id, model).subscribe((data) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'Sales Order updated successfully.',
              withoutConfirm: true
            });

            if (!saveOnly) {
              this._closeForm();
            }

            this._handleAfterSave(afterSave);

            if (afterSave == 'print' || afterSave == 'copy' || afterSave == 'save' || afterSave == 'submit') {
              this.retrieveGridaftersave()
            }
            else {
              this._model = {};

              this._onClear();
              this._pageState = 2;
            }
          });
        }
        else {
          this._salesOrdersService.createSalesOrder(model).subscribe((data: any) => {
            this.note.createNote(parseInt(data));
            this.transactionId = data.data;

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'Sales Order created successfully.',
              withoutConfirm: true
            });

            model.id = data.data;
            this._salesOrdersService.salesOrderAdded.emit(model);

            if (!saveOnly) {
              this._closeForm();
            }
            else {
              this._note = undefined;
              this._pageState = PageState.EDIT;
              this.isEditMode = true;
              this._isNew = false;
              this._model.id = data.data;
              this.rertrievesalesorder(data.data);
              if (data.extraData) {
                this._inventoryGridData.forEach(element => {
                  var SavedId = data.extraData.find((x: any) => x.stockItemId == element.stockItemId);
                  if (SavedId) {
                    element.id = SavedId.id;
                  }
                });
              }
            }

            this._handleAfterSave(afterSave);
          });
        }
      }
    }
  }

  _handleAfterSave(_action: string) {
    switch (_action) {
      case 'new': {
        this._onClear();
        this._pageState = 2;
        break;
      }
      case 'print': {
        this._pageState = PageState.EDIT;
        this._model.id = this.transactionId;
        this._showPrintWindow();
        break;
      }
      case 'copy': {
        this._pageState = PageState.COPY;
        this._model.id = null;
        this._model.soNumber = '';
        this._form.patchValue({
          soNumber: ''
        });
        break;
      }
    }
  }



  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _onClear(ClearForNewItem: boolean = true) {
    this._selectedDocumentsKeys = [];
    this._uploadedStream = [];
    this._selectedExistingFiles = [];
    this._approvalCycleState = null;
    this._uploaderSelectMessage = 'Upload file..';
    this.transactionId = null;
    this.unitPriceInput.value == null
    this._unitPrice = new FormControl();;
    this.stockSalesOrder = null;
    this.hasApprovalCycle = false;
    this._form.patchValue({
      //site: null,
      orderDate: new Date(),
      dueDate: null,
      expectedDeliveryDate: null,
      isClosed: 'false',
      soNumber: null,
      customer: null,
      address: null,
    });
    this._selectedAccount.setValue(null);
    this._selectedStockItem.setValue(null);
    this._soNumber.setValue(null);
    this._defaultQuantity.setValue(null);
    this._defaultDate.setValue(null);
    this._defaultUnitPrice.setValue(true);
    this.addressTextarea.nativeElement.value = "";
    this.customerAddressTextarea.nativeElement.value = "";
    this._clearGridData();
    if (ClearForNewItem) {
      //this.setSiteId();
      this._model.id = null;
      this._isNew = true;
    }
  }

  _clearGridData() {
    this._subtotal = 0;
    this._shipping = 0;
    this._discount = 0;
    this._otherAdjustment = 0;
    this._tax = 0;
    this._total = 0;
    this._inventoryGridData = [];
  }

  _closePrint() {
    this.showReports = false;
  }
  _closeForm() {
    var closeComponent = {
      component: 'salesOrders',
      isClosed: true
    }
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('salesOrders');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _showPrintWindow() {
    if (this._model && this._model.id) {
      this.transactionId = this._model.id;
    }
    if (this._form.controls['site'].value) {
      this._reportService.ReportsByCategoryName('salesOrders', false, this._form.controls['site'].value.id).subscribe(
        (x: any) => {

          this.salesOrderReports = x;
          this.showReports = true;
        });
    }
    else if (this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Select Site Code',
        withoutConfirm: true
      });
    }

  }

  _showPrintPicklistWindow() {
    const hasApproval = this.stockSalesOrder ? !!this.stockSalesOrder.hasApprovalCycle : this.hasApprovalCycle;
    if (hasApproval && !this.stockSalesOrder?.isApproved) {
      return;
    }
    if (this._model && this._model.id) {
      this.transactionId = this._model.id;
    }
    if (this._form.controls['site'].value) {
      this._reportService.ReportsByCategoryName('salesOrderToPickList', false, this._form.controls['site'].value.id).subscribe(
        (x: any) => {

          this.salesOrderReports = x;
          this.showReports = true;
        });
    }
    else if (this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Select Site Code',
        withoutConfirm: true
      });
    }

  }
  _showSOToPOWindow() {
    const hasApproval = this.stockSalesOrder ? !!this.stockSalesOrder.hasApprovalCycle : this.hasApprovalCycle;
    if (hasApproval && !this.stockSalesOrder?.isApproved) {
      return;
    }
    //   this.retrieveGridaftersave()
    setTimeout(() => {
      let SOrder = this.kendoComboSOrder;
      ɵgetHostElement(SOrder).classList.add('focusedCombobox');
      //this.kendoComboSOrder.toggle(true);
      //this.kendoComboSOrder.focus();
      this._addClassActive = false;
    }, 500);
    this.showSOToPOWindow = true;
    if (this._model && !this._isNew) {

      let modeldata: any
      let params = this._model.id
      this._salesOrdersService.getSalesOrder(params)

        .subscribe((model) => {
          modeldata = model
          //this._inventoryGridData = [] ;
          modeldata.stockSalesOrderDetails.forEach((element: any) => {

            this._SOtoPOGridData.push({
              stockItemId: element?.stockItem?.id,
              stockItemNumber: element?.stockItem?.number,
              stockDescription: element?.stockItem?.description,
              quantityToOrder: element?.unitsOrdered > 0 ? element?.unitsOrdered - element?.unitsIssued : 0,
              posobackquantity: element?.unitsOrdered > 0 ? element?.unitsOrdered - element?.unitsIssued : 0,
              receiveUOM: element?.stockItem?.receiveUnitOfMeasure?.code,
              cost: element?.stockItem?.costInfo?.cost,
              isTaxable: element?.stockItem?.costInfo?.isTaxable,
              stockSalesOrdderId: modeldata.id
            });
            // this._inventoryGridData.push({
            //   id:element.id,
            //   backorderQty:0,
            //   unitsIssued: 0,
            //   stockItemId: element.stockItemId,
            //   itemNumber: element.stockItem.number,
            //   description: element.stockItem.description,
            //   unitsOrdered: Number(element.unitsOrdered)  ,
            //   uom: element.stockItem.issueUnitOfMeasure.code,
            //   unitPrice: element.unitPrice ,
            //   extendedPrice: element.extendedPrice ,
            //   isTaxable: element.isTaxable??element.stockItem.costInfo?.isTaxable
            // });
          })
        });



      // this._model.stockSalesOrderDetails.forEach((element: any) => {
      //   this._SOtoPOGridData.push({
      //     stockItemId: element?.stockItem?.id,
      //     stockItemNumber: element?.stockItem?.number,
      //     stockDescription: element?.stockItem?.description,
      //     quantityToOrder:element?.unitsOrdered > 0 ? element?.unitsOrdered - element?.unitsIssued : 0,
      //     posobackquantity: element?.unitsOrdered > 0 ? element?.unitsOrdered - element?.unitsIssued : 0,
      //     receiveUOM: element?.stockItem?.receiveUnitOfMeasure?.code,
      //     cost: element?.stockItem?.costInfo?.cost,
      //     isTaxable: element?.stockItem?.costInfo?.isTaxable
      //   });
      // });
    }
    this._loadVendorsDD(this._form.controls['site'].value?.id);
  }
  _closeSOToPOForm() {
    this._SOtoPOGridData = [];
    this._selectedSOtoPOOrderOption.reset();
    this._selectedSOtoPOVendorOption.reset();
    this.showSOToPOWindow = false;
  }
  _printReceiptReport() {
    var reportId = this.selectReceiptReport.value.id;
    this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.EDIT, { reportId: reportId, transactionId: this.transactionId });
    this.showReports = false;
    // this._onClear();
  }

  getSOtoPOSettings() {
    this._soToPoPreferencesService.getSOToPOPreference()

      .subscribe((res: any) => {
        this._sOtoPOSettings = res;
      });
  }

  _loadVendorsDD(siteId: number = null) {
    // return this._vendorsService.getVendorsListingWithEntityAddress()
    //   .subscribe((data: any) => {
    //     this._vendors = data;
    //     this._vendorsFiltered = data;
    //   });
    return this._vendorsService.getVendorsListing(null, siteId)
      .subscribe((data: any) => {
        this._vendors = data;
        this._vendorsFiltered = data;
      });
  }
  _handleVendorsChange(value: any, rowIndex: any) {
    // if (this._selectedSOtoPOVendorOption.value) {
    //   this._SOtoPOGridData.forEach((element: any) => {
    //     element.vendor = value;
    //   });
    // }
    // else
    //   this._SOtoPOGridData[rowIndex].vendor = value;

    if (rowIndex == 0)
      this._SOtoPOGridData[rowIndex].vendor = value;

    if (this._poVendorEnable == true) {
      this._SOtoPOGridData.forEach((element: any) => {
        if (element.isDisabledVendor)
          element.vendor = this._SOtoPOGridData[0].vendor
      });
    }
    else
      this._SOtoPOGridData[rowIndex].vendor = value;
  }

  _handleVendorsFilter(value: any) {
    this._vendorsFiltered = this._vendors.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  private generateBarcodeforPo(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('purchaseOrders', quantity);
  }
  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  _poNumberValueChange(event: any, rowIndex: any) {
    if (rowIndex == 0)
      this._SOtoPOGridData[rowIndex].PONumber = event;
    if (this._poOrderEnable == true) {
      this._SOtoPOGridData.forEach((element: any) => {
        if (element.isDisabledPo) {
          if (element.PONumber == undefined)
            element.PONumber = {}
          element.PONumber = this._SOtoPOGridData[0].PONumber
        }
      });
    }
    else
      this._SOtoPOGridData[rowIndex].PONumber = event;
  }

  _orderedQuantityValueChanged(event: any, rowIndex: any) {
    // this._SOtoPOGridData.forEach((element: any) => {
    //   element.quantityToOrder = event;
    // })
    this._SOtoPOGridData[rowIndex].quantityToOrder = event;
  }

  _potoSOProcess() {
    let isInvalidVemdor = this._SOtoPOGridData.filter(x => x.vendor == undefined || x.vendor == null);
    let isInvalidPo = this._SOtoPOGridData.filter(x => x.PONumber == undefined || x.PONumber == null || x.PONumber == '');

    if (!this._SOtoPOGridData.length || isInvalidVemdor.length > 0 || isInvalidPo.length > 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill all items to create the Purchase Order.',
        withoutConfirm: true
      });
    }
    else {
      if (this._selectedSOtoPOOrderOption.value?.value === true) {
        let model: any = {};
        model['poNumber'] = this._SOtoPOGridData[0].PONumber;
        model['vendorId'] = this._SOtoPOGridData[0].vendor.id;
        model['siteId'] = this._form.value.site.id;
        model['stockPurchaseOrderStatusId'] = 2;
        model['isClosed'] = false;
        model['subtotal'] = 0;
        model['shipping'] = 0;
        model['discount'] = 0;
        model['orderDate'] = new Date();
        model['otherAdjustment'] = 0;
        model['tax'] = 0;
        model['total'] = 0;
        model['isFromSo'] = true;
        model['StockSalesOrderId'] = this._SOtoPOGridData[0].stockSalesOrdderId;
        model['items'] = this._SOtoPOGridData.map((x) => {
          return {
            stockItemId: x.stockItemId,
            // unitsOrdered: x.quantityToOrder,
            unitsOrdered: x.quantityToOrder,
            unitCost: x.cost,
            extendedCost: (x.cost ?? 0) * (x.quantityToOrder ? + x.quantityToOrder : 1),
            isTaxable: x.isTaxable
          };
        });

        this._purchaseOrdersService
          .createPurchaseOrder(model)

          .subscribe((data) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'Purchase Order created successfully.',
              withoutConfirm: true
            });
            this._closeForm();
          });
      }
      else {
        //TODO:: make this behavuior in backend by pass paramters 
        const poMap = new Map();
        this._SOtoPOGridData.forEach((element) => {
          const key = `${element.PONumber}_${element.vendor.id}`;
          if (!poMap.has(key)) {
            poMap.set(key, {
              poNumber: element.PONumber,
              vendorId: element.vendor.id,
              siteId: this._form.value.site.id,
              stockPurchaseOrderStatusId: 2,
              isClosed: false,
              subtotal: 0,
              shipping: 0,
              discount: 0,
              orderDate: new Date(),
              otherAdjustment: 0,
              tax: 0,
              total: 0,
              isFromSo: true,
              StockSalesOrderId: element.stockSalesOrdderId,
              items: []
            });
          }
          const item = {
            stockItemId: element.stockItemId,
            unitsOrdered: element.quantityToOrder,
            unitCost: element.cost,
            extendedCost: (element.cost ?? 0) * (element.quantityToOrder ? + element.quantityToOrder : 1),
            isTaxable: element.isTaxable
          };
          poMap.get(key).items.push(item);
        });

        const models = Array.from(poMap.values());
        const requests = models.map(model => this._purchaseOrdersService.createPurchaseOrder(model));

        forkJoin(requests).subscribe({
          next: () => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'Purchase Order(s) created successfully.',
              withoutConfirm: true
            });
            this._closeForm();
          },
          error: (err) => {
            this._layoutComponent.openPopup({
              title: 'Error',
              message: 'Error creating Purchase Orders.',
              withoutConfirm: true
            });
          }
        });
      }
    }
  }

  _autoGeneratePONumber() {
    // if (this._selectedSOtoPOOrderOption.value) {

    let counter = this._poOrderEnable ? 1 : this._SOtoPOGridData.length;
    this.generatePOBarcode(counter)

      .subscribe((data: any) => {
        if (counter == 1) {
          this._SOtoPOGridData.forEach((element: any) => {
            element.PONumber = data.result.toString();
          });
        }
        else {
          let poBarcodes = data.result.split(',');
          this._SOtoPOGridData.forEach((element: any, index: any) => {
            element.PONumber = poBarcodes[index];
          });
        }
      });
    // }
  }

  _onautoGenerateChange(event: any) {
    if (event.target.checked) {
      this._autoGeneratePONumber();
    }
  }

  getSOTOPOAuth() {
    this._gridFields.getFileAuthorization('mnuSOTOPO', this._currentUser.appRole.id)
      .subscribe((x: GridFieldAuthorization) => {
        this._soToPoAuth = x;
      });
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    // let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    // mobiletabstrip.classList.toggle('visibletab');
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        if (x && Array.isArray(x) && !x.find((tab: any) => tab.name === 'General')) {
          x.unshift({
            id: 1,
            name: 'General',
            order: 1,
            isCustom: false,
            page: this._page
          });
        }
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  // _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
  //   Object.keys(customFieldsValue).forEach(key => {
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == "null") {
  //       customFieldsValue[key] = "";
  //     }
  //     if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
  //       this._customFields[tabId].find(x => x.name == key).entityId = -1;
  //       this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: "null", entityId: -1 ,customFieldId:-1 });
  //     }
  //     var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //   });
  //   this._customFieldsValue = customFieldsValue;
  // }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    if (this._customFieldsValue == undefined) { this._customFieldsValue = []; }
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });

  }


  _addNewField(tabId: number) {
    this._selectedLabelId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
      else {
        this._editFormActive = true;
        this._isCustomfieldsFormValue = true;
      }
    }

  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == "stockItems" ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
          this._dataTabs.splice(this._dataTabs.indexOf(deletedTab), 1);
          //go to zero based tab
          this.screenTabStrip.selectTab(0);
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response["message"],
            withoutConfirm: true
          });
          if (response["close"] != null) {
            if (response["close"] == true) {
              // this._closeForm();
            } else {
              return;
            }
          }
        }
        //   this._closeForm();
      });

  }

  // _openRenameForm(objectCode: string, isMandatory: boolean = false) {
  //   this._selectedLabelObjectCode = objectCode; //todo send system field label id
  //   //return; //open form once label id is set

  //   this._editFormActive = true;
  //   this._isRenameFormValue = true;
  //   this._isRenameCustomFormValue = false;
  //   this._isRenameLabel = true;
  //   this._isMandatory = isMandatory;
  // }

  _openRenameForm(
    objectCode: string,
    isMandatory: boolean = false,
    onlyRequired: boolean = false,
    hasRequired: boolean = false
  ) {
    this._selectedLabelObjectCode = objectCode;
    //todo send system field label id
    //return;
    //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
    this._isTransaction = true;
    this._onlyRequired = onlyRequired;
    this._hasRequired = hasRequired;
  }

  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _onDocumentRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _onCancel() {
    this._closeForm();
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }
  _onDocumentbjectRowSelectionChanges(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this._isTransaction = false;
    this._onlyRequired = false;
    this._hasRequired = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels(true);
    this.getFormTabs();
    this.getAuth();
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: GridFieldSummary[]) => {
        this._systemFields = [...x];
        this._editedSystemFields = [...x];
        this.loadCustomFields(this._model?.id?.toString());
      })
  }
  private loadCustomFields(entityId?: string) {
    //this._pacer.start();
    this._customFieldsService
      .getCustomFields(this._entity, this._page)

      .subscribe((data) => {
        data = data.filter(x => x.formTab?.page == this._page);
        if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }

        this.setMandatoryFields();
      });
  }
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach((element: { isCustomField: any; formTab: any; formTabId: any; }) => {

        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.screenTabs) {
        let tabElementList = this.screenTabs.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find((x: { name: any; page: string; formtab: { page: string; }; }) => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element: { isCustomField: any; formTab: { name: any; }; customFieldsData: any[]; name: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        if (element.customFieldsData != undefined) {
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }
  // private loadCustomFields(entityId?:string ) {
  //     .getCustomFields('stock',this._page,entityId)
  //     
  //     .subscribe((data) => {
  //       if (this._model != null && this._model.id != null) {
  //         let that = this;
  //         data.map(function (x) {
  //           x.entityId = that._model.id;
  //         });
  //       }
  //       var tabIds = data.map(item => item.formTabId)
  //         .filter((value, index, self) => self.indexOf(value) === index);

  //       const grouped = this.groupBy(data, (item: { formTabId: any; }) => item.formTabId);
  //       let that = this;
  //       tabIds.forEach(function (formTabId) {
  //         that._customFields[formTabId] = grouped.get(formTabId);
  //       });
  //     });

  //   this._customFieldsService
  //     .getFormTabsByPage(this._page)
  //     
  //     .subscribe((data: any) => {
  //       //get custom tabs first
  //       this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //     });
  // }

  private loadLabels(isClosed: boolean = false) {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        if (isClosed) {
          this._initForm();
        }
      })
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  getLabel(objectCode: any, tabid: any = null) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : null;
    }
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      })
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
    this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response["message"] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response["message"],
                withoutConfirm: true
              });
              if (response["close"] != null) {
                if (response["close"] == true) {
                  this.getSystemFieldsAndCustomFields();
                  //this.loadCustomFields(this._model?.id?.toString());
                  this._deactivatedFieldsForm = false;
                  var deletedTab = this._dataTabs.find(f => f.id == item.formTabId && f.isCustom == true);
                  if (deletedTab == undefined) {
                    this.getFormTabs();
                  }
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }
  _onEditForms() {
    this._isEditForms = true;
  }

  scrollCombobox(event: any) {
    this.isOpened = true;
    if (this.clearTimeout) clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
            this.beginScroll = true;
            this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
            //this._loadItems();
          }
        });
      }
    }, 0);
  }

  // scrollCombobox(event:any){
  //       this.isOpened = true;
  //       if (this.clearTimeout) clearTimeout(this.clearTimeout);
  //      this.clearTimeout = setTimeout(() => {
  //       if (this.isOpened) {
  //       this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e:any) => {
  //       if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
  //        this.beginScroll = true;
  //         this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
  //         //var siteId =  this._form.get('site').value;
  //         this._loadItemsDD();
  //       }
  //     });
  //           }
  //       }, 2500);
  //   }

  onBlur() {
    this.beginScroll = false;
    this._items = [];
    //this._itemsFiltered = [];
    this.comboBoxpagingationParams.currentItem = '0';
    var siteId = this._form.get('site').value;
    this._loadItemsDD(siteId.id);
  }

  // #region File Library
  //Images / Picutres
  _getFilesGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._filesPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._filesPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._filesPageName, (gridColumns) => {
      this._filesGridFields = gridColumns;
    });
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._filesGridFields == undefined || this._filesGridFields.length == 0) {
        this._getFilesGridFields();
      }
      this._showImagesGrid = true;
    }
  }
  _closeImagesWindow(): void {
    this._showImagesGrid = false;
    this._isDialiog = false;
  }
  _returnSelectedImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = false;
        this._selectedImagesKeys = this._selectedImages;
        this._addPicture();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = false;
      this._selectedImagesKeys = this._selectedImages;
      this._addPicture();
    }
  }
  _addPicture(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesPics =
        this._purchaseOrderFilesPics === null ? [] : this._purchaseOrderFilesPics;
      if (this._selectedObjectImages.length > 0) {
        this._selectedObjectImages.forEach((element: any) => {
          let exists = this._purchaseOrderFilesPics.find(f => f.fileId == element.id);
          if (exists == undefined) {
            delete element.fileAccounts;
            let addedFileItem: stockSalesOrderFile = <stockSalesOrderFile>({
              fileId: element.id,
              file: element,
              stockPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesPics.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: stockSalesOrderFile = <stockSalesOrderFile>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        stockPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesPics.push(addedFileItem);
    }
  }
  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }
  _onImageObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    this._selectedObjectImages = e;
  }
  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(
      this._selectedAccountIds,
      params,
      model
    );
  };
  _setPrimaryPic(data: any) {
    this._purchaseOrderFilesPics.forEach((element: stockSalesOrderFile) => {
      if (element !== data) {
        element.purchaseOrderFileisPrimary = false;
      }
      else {
        element.purchaseOrderFileisPrimary = true;
      }
    });
  }
  _removePicHandler(event: any) {
    const index = this._purchaseOrderFilesPics.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesPics.splice(index, 1);
      this._selectedImagesKeys.splice(this._selectedImagesKeys.indexOf(event), 1);
    }
  }
  _removeFileFromLibrary(event: stockSalesOrderFile) {
    //Delete Logic Goes Here
    this._removePicHandler(event);

  }
  _onSelectedImagesChanged(e: any[]) {
  }
  _onSelectedImagesRowChanged(e: any[]) {
  }
  //Documents
  _getDocumentsGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._documentsPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._documentsPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._documentsPageName, (gridColumns) => {
      this._documentsGridFields = gridColumns;
    });
  }
  _selectDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._documentsGridFields == undefined || this._documentsGridFields.length == 0) {
        this._getDocumentsGridFields();
      }
      this._showDocumentsGrid = true;
    }
  }
  _closeDocumentsWindow(): void {
    this._showDocumentsGrid = false;
  }
  _returnSelectedDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = false;
        this._selectedDocumentsKeys = this._selectedDocuments;
        this._addDocument();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      this._selectedDocumentsKeys = this._selectedDocuments;
      this._addDocument();
    }
  }
  _addDocument(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesDoc =
        this._purchaseOrderFilesDoc === null ? [] : this._purchaseOrderFilesDoc;

      if (this._selectedObjectDocuments.length > 0) {
        this._selectedObjectDocuments.forEach((element: any) => {
          let exists = this._purchaseOrderFilesDoc.find(f => f.fileId == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: stockSalesOrderFile = <stockSalesOrderFile>({
              fileId: element.id,
              file: element,
              stockPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesDoc.push(addedFileItem);
          }
        });
      }
    }
    else {
      const docId = fileData.picObject?.id || fileData.response?.id || fileData.response?.responseId;
      if (docId) {
        let exists = this._purchaseOrderFilesDoc.find(f => f.fileId == docId && f.status == EntityStatusOptions.Active);
        if (exists == undefined) {
          let addedFileItem: stockSalesOrderFile = <stockSalesOrderFile>({
            fileId: docId,
            file: fileData.picObject?.file || fileData.picObject || fileData.response,
            stockPurchaseOrderId: this._model.id ? this._model.id : 0,
            status: EntityStatusOptions.Active,
          });
          this._purchaseOrderFilesDoc.push(addedFileItem);
        }
      }
    }
  }
  _removeDocHandler(event: any) {
    const index = this._purchaseOrderFilesDoc.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesDoc.splice(index, 1);
      this._selectedDocumentsKeys.splice(this._selectedDocumentsKeys.indexOf(event), 1);
    }
  }
  _onDocumentsRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }
  _onDocumentObjectRowSelectionChange(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  _getAccountDocumentsxxxxx = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  };
  _doDownloadFile(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  //Videos
  _getVideosGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._videosPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._videosPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._videosPageName, (gridColumns) => {
      this._videosGridFields = gridColumns;
    });
  }
  _selectVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._videosGridFields == undefined || this._videosGridFields.length == 0) {
        this._getVideosGridFields();
      }
      this._showVideoGrid = true;
    }
  }
  _closeVideosWindow(): void {
    this._showVideoGrid = false;
  }
  _returnSelectedVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = false;
        this._selectedVideosKeys = this._selectedVideos;
        this._addVideo();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showVideoGrid = false;
      this._selectedVideosKeys = this._selectedVideos;
      this._addVideo();
    }
  }
  _addVideo(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesVideo =
        this._purchaseOrderFilesVideo === null ? [] : this._purchaseOrderFilesVideo;

      if (this._selectedObjectVideos.length > 0) {
        this._selectedObjectVideos.forEach((element: any) => {
          let exists = this._purchaseOrderFilesVideo.find(f => f.fileId == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: stockSalesOrderFile = <stockSalesOrderFile>({
              fileId: element.id,
              file: element,
              stockPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesVideo.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: stockSalesOrderFile = <stockSalesOrderFile>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        stockPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesVideo.push(addedFileItem);
    }
  }
  _removeVideoHandler(event: any) {
    const index = this._purchaseOrderFilesVideo.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesVideo.splice(index, 1);
      this._selectedVideosKeys.splice(this._selectedVideosKeys.indexOf(event), 1);
    }
  }
  _onVideosRowSelectionChanges(e: any[]) {
    this._selectedVideos = [];
    e.forEach((item) => {
      this._selectedVideos.push(+item);
    });
  }
  _onVideoObjectRowSelectionChange(e: any[]) {
    this._selectedObjectVideos = [];
    this._selectedObjectVideos = e;
  }
  _getAccountVideos = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getVideos(params, model);
  };
  _doDownloadVideo(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  // #endregion
  //#region Multi Site Functions
  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites()

      .subscribe((data: any) => {
        this._sites = data || [];
        this._sitesFiltered = this._sites;

        this.initAllSitesDropDown(IsEdit, SavedSite);

      });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this._form.controls['site'].setValue(this._siteSelected);
    this._loadCustomersDD(this._form.controls['site'].value?.id, isEdit);
    this.getStockItemDDPaging(this._form.controls['site'].value?.id);
    this._loadAddressesDD(this._form.controls['site'].value?.id);
  }
  // _handleSitesFilter(value: any) {
  //   this._sitesFiltered = this._sites.filter(
  //     (s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
  //   );
  // }

  _handleSitesChange(event: any) {
    let _currentVal = this._form.value.site;


    setTimeout(() => {
      if (this._inventoryGridData.length > 0 || this._form.controls['customer'].value
        || this._form.controls['address'].value
      ) {
        if (confirmSiteSub)
          confirmSiteSub.unsubscribe();
        var confirmSiteSub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
          if (data == true) {
            this._inventoryGridData = [];
            this._clearGridData();
            this._selectedStockItem.setValue(null);
            this._form.controls['customer'].setValue(null);
            this._form.controls['address'].setValue(null);
            this._handleCustomersChange(null);
            this._siteSelected = event;
            this._form.controls['site'].setValue(event);
            this._loadCustomersDD(this._form.controls['site'].value?.id);
            this.getStockItemDDPaging(this._form.controls['site'].value?.id);
            this._loadAddressesDD(this._form.controls['site'].value?.id);
          }
          else {
            this._form.patchValue({
              site: _currentVal
            });
          }
        });
        this._layoutComponent.openPopup({
          title: 'Notification',
          message: `Changing the site will clear the selected items, customer, address of the transaction. Continue?`
        });
      }
      else {
        this._form.controls['site'].setValue(event);
        this._selectedStockItem.setValue(null);
        this._form.controls['customer'].setValue(null);
        this._form.controls['address'].setValue(null);
        this._handleCustomersChange(null);
        this._siteSelected = event;
        this._loadCustomersDD(this._form.controls['site'].value?.id);
        this.getStockItemDDPaging(this._form.controls['site'].value?.id);
        this._loadAddressesDD(this._form.controls['site'].value?.id);
      }
    }, 100);
  }
  //#endregion
  _showCustomerNotesWindow(id: number) {
    this._customersService.getCustomer(id)

      .subscribe((model: any) => {
        this._customerNotesModel = model;
        this._showCustomerFileNotes = true;
      });
  }
  _closeCustomerNotesWindow() {
    this._showCustomerFileNotes = false;
  }
  _showNotesWindow(id: number) {
    this._customersService.getCustomer(id)

      .subscribe((model: any) => {
        this._customerNotesModel = model;
        this._showCustomerFileNotes = true;
      });
  }


}
